<template>

  <section class="container">
    <div class="mdl-grid mdl-grid--no-spacing center-items">
        <div class="mdl-cell mdl-cell--10-col mdl-card mdl-shadow--2dp">
          <header class="mdl-card__title mdl-card--border">
            <h3 class="mdl-card__title-text mdl-card--border">
                Create New Bill
            </h3>
          </header>
          <div>
              <AddItem :parentData="items" v-on:childToParent="onAddItemsClick"></AddItem>
          </div>

        </div>
    </div>
    <div class="mdl-grid mdl-grid--no-spacing center-items">
      <div class="mdl-cell mdl-cell--10-col mdl-card mdl-shadow--2dp">
        <div class="center-items mdl-color--grey-100 mdl-color-text--grey-600 mdl-card__title">
          <h2 class="mdl-card__title-text">Customer Details</h2>
        </div>

          <form @submit="saveContact" class="mdl-grid center-items">
            <div v-mdl class="mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <input class="mdl-textfield__input" type="text"
               id="firstname" v-model="firstname" pattern="[A-Z,a-z]+" v-bind:required="firstnameRequired">
              <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="firstname">First Name</label>
            </div>
            <div v-mdl class="mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <input class="mdl-textfield__input" type="text"
               id="lastname" v-model="lastname" pattern="[A-Z,a-z]+" v-bind:required="lastnameRequired">
              <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="lastname">Last Name</label>
            </div>
            <div v-mdl class="mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <input class="mdl-textfield__input" type="text"
               id="vehiclenumber" v-model="vehiclenumber" pattern="[A-Z,a-z,0-9]+" v-bind:required="vehiclenumberRequired">
              <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="vehiclenumber">Vehicle Number</label>
            </div>
            <div v-mdl class="mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <input class="mdl-textfield__input" type="text"
               id="phonenumber" v-model="phonenumber" pattern="[A-Z,a-z]+" v-bind:required="phonenumberRequired">
              <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="phonenumber">Phone Number</label>
            </div>
            <div v-mdl class="mdl-cell mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
              <input class="mdl-textfield__input" type="text"
               id="emailaddress" v-model="emailaddress">
              <label class="mdl-textfield__label mdl-color-text--blue-grey-500" for="emailaddress">Email Address</label>
            </div>
          </form>

        <div class="mdl-grid mdl-card__actions mdl-card--border">
          <button v-mdl @click="saveContact"
            class="mdl-color-text--blue-grey-900 mdl-card--border mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect">Save</button>
          <router-link v-mdl class="mdl-color-text--blue-grey-900 mdl-card--border mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
           v-bind:to="{ name: 'home'}">Discard</router-link>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
// import firebase from 'firebase/app'
import 'firebase/firestore'
import db, {MyApp} from '../main.js'
import AddItem from '@/components/AddItem'

export default {
  name: 'new-bill',
  components: {
    AddItem
  },
  props: {
    parentData: Object
  },
  data () {
    return {
      firstname: null,
      lastname: null,
      emailaddress: null,
      phonenumber: null,
      amount: null,
      items: null,
      vehiclenumber: null,
      firstnameRequired: false,
      lastnameRequired: false,
      phonenumberRequired: false,
      vehiclenumberRequired: false
    }
  },
  methods: {
    saveContact (event) {
      if (!this.validate()) {
        return false
      }
      event.preventDefault()
      const slug = this.generateUUID()
      this.total()
      // db.collection('companies/' + this.user.company + '/bills').add({
      this.incrementAndUpdateBill(slug)
    },
    incrementAndUpdateBill (slug) {
      const user = this.$store.state.userData.user
      let billDocRef
      let newBillState
      db.runTransaction(t => {
        let companyRef = db.collection('companies').doc(user.company)
        return t.get(companyRef)
          .then(doc => {
            let currentBillNumber = doc.data().currentBillNumber + 1
            t.update(companyRef, {currentBillNumber: currentBillNumber})
            billDocRef = db.collection('companies/' + user.company + '/bills').doc()
            newBillState = {
              firstname: this.firstname,
              lastname: this.lastname,
              emailaddress: this.emailaddress,
              phonenumber: this.phonenumber,
              amount: this.amount,
              items: this.items,
              slug: slug,
              timestamp: new Date().getTime(),
              type: MyApp.vue.env,
              vehiclenumber: this.vehiclenumber,
              sequenceNumber: currentBillNumber
            }
            t.set(billDocRef, newBillState)
          })
      }).then(result => {
        console.log('incrementAndUpdateBill Transaction success!')
        // console.log(`${user.company}/${billDocRef.id}/success/${billDocRef.sequenceNumber}`)
        this.$store.state.newBillState = newBillState
        this.$router.push({ name: 'view-bill', params: { bill: billDocRef.id, company: user.company, success: 'success' } })
      }).catch(err => {
        console.log('incrementAndUpdateBill Transaction failure:', err)
      })
    },
    // getUserAndUpdate (slug) {
    // db.collection('users').doc(firebase.auth().currentUser.uid).get()
    //   .then(doc => {
    //     if (!doc.exists) {
    //       console.log('No such user with id: ' + firebase.auth().currentUser.uid)
    //     } else {
    //       console.log('Document user data:', doc.data())
    //       this.incrementAndUpdateBill(slug, doc.data())
    //     }
    //   })
    //   .catch(err => {
    //     console.log('Error getting document', err)
    //   })

    // }
    // ,
    // getCompany () {
    //   db.collection('companies').doc(this.getUser().company).get()
    //     .then(doc => {
    //       if (!doc.exists) {
    //         console.log('No such company')
    //       } else {
    //         console.log('Document company data:', doc.data())
    //         return doc.data()
    //       }
    //     })
    //     .catch(err => {
    //       console.log('Error getting document', err)
    //     })
    // },
    generateUUID () {
      let d = new Date().getTime()
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
      return uuid
    },
    onAddItemsClick (items) {
      this.items = items
    },
    total () {
      this.amount = this.items.reduce(function (accumulator, item) {
        return accumulator + (Math.trunc(item.qty) * Math.trunc(item.unitPrice))
      }, 0)
    },
    validate () {
      let status = true

      if (this.firstname === null) {
        this.firstnameRequired = 'required'
        status = false
      }
      if (this.lastname === null) {
        this.lastnameRequired = 'required'
        status = false
      }
      if (this.phonenumber === null) {
        this.phonenumberRequired = 'required'
        status = false
      }
      if (this.vehiclenumber === null) {
        this.vehiclenumberRequired = 'required'
        status = false
      }
      console.log(status)
      return status
    }
  },
  created () {
    this.$nextTick(() => {
      window.componentHandler.upgradeDom()
      window.componentHandler.upgradeAllRegistered()
    })
  }
}
</script>

<style scoped>
.mdl-grid{
  margin: 8px;
}
.mdl-cell.mdl-textfield{
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/NewBill.vue